<script>
import { mapActions } from 'vuex';

export default {
  name: 'SsoRedirect',
  methods: {
    ...mapActions(['redirectSso']),
  },
  async beforeMount() {
    await this.redirectSso()
  },
}
</script>
<style scoped>
</style>
